import { render, staticRenderFns } from "./flocker.vue?vue&type=template&id=05f92896&"
import script from "./flocker.vue?vue&type=script&lang=js&"
export * from "./flocker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports